import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Story from "@/components/sections/Story";
import Menu from "@/components/sections/Menu";
import Process from "@/components/sections/Process";
import Gallery from "@/components/sections/Gallery";
import Footer from "@/components/sections/Footer";

import { AuthProvider } from "@/staff/AuthContext";
import { Protected } from "@/staff/Protected";
import Login from "@/staff/pages/Login";
import Register from "@/staff/pages/Register";
import Dashboard from "@/staff/pages/Dashboard";
import Usage from "@/staff/pages/Usage";
import QuickUsage from "@/staff/pages/QuickUsage";
import QuickBuy from "@/staff/pages/QuickBuy";
import Admin from "@/staff/pages/Admin";
import MgmtDashboard from "@/staff/management/pages/MgmtDashboard";
import MgmtSales from "@/staff/management/pages/MgmtSales";
import MgmtCatalog from "@/staff/management/pages/MgmtCatalog";
import MgmtDailyPowder from "@/staff/management/pages/MgmtDailyPowder";
import MgmtQuickUsage from "@/staff/management/pages/MgmtQuickUsage";
import MgmtInventory from "@/staff/management/pages/MgmtInventory";
import Receive from "@/staff/pages/Receive";

import PrivacyPolicy from "@/legal/PrivacyPolicy";
import Terms from "@/legal/Terms";
import DeleteAccount from "@/legal/DeleteAccount";
import AppDownload from "@/pages/AppDownload";

function MarketingSite() {
  return (
    <div className="App" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Story />
        <Menu />
        <Process />
        <Gallery />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<MarketingSite />} />
          <Route path="/app" element={<AppDownload />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/staff/login" element={<Login />} />
          <Route path="/staff/register" element={<Register />} />
          <Route
            path="/staff/dashboard"
            element={
              <Protected>
                <Dashboard />
              </Protected>
            }
          />
          <Route
            path="/staff/usage"
            element={
              <Protected>
                <Usage />
              </Protected>
            }
          />
          <Route
            path="/staff/quick-usage"
            element={
              <Protected>
                <QuickUsage />
              </Protected>
            }
          />
          <Route
            path="/staff/quick-buy"
            element={
              <Protected>
                <QuickBuy />
              </Protected>
            }
          />
          <Route
            path="/staff/admin"
            element={
              <Protected adminOnly>
                <Admin />
              </Protected>
            }
          />
          <Route
            path="/management"
            element={
              <Protected adminOnly>
                <MgmtDashboard />
              </Protected>
            }
          />
          <Route
            path="/management/sales"
            element={
              <Protected adminOnly>
                <MgmtSales />
              </Protected>
            }
          />
          <Route
            path="/management/catalog"
            element={
              <Protected adminOnly>
                <MgmtCatalog />
              </Protected>
            }
          />
          <Route
            path="/management/daily-powder"
            element={
              <Protected adminOnly>
                <MgmtDailyPowder />
              </Protected>
            }
          />
          <Route
            path="/management/quick-usage"
            element={
              <Protected adminOnly>
                <MgmtQuickUsage />
              </Protected>
            }
          />
          <Route
            path="/management/inventory"
            element={
              <Protected adminOnly>
                <MgmtInventory />
              </Protected>
            }
          />
          <Route
            path="/staff/receive"
            element={
              <Protected>
                <Receive />
              </Protected>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
